<template>
  <div id="app">
    <!-- <van-sticky>
      <van-nav-bar title="积分商城" />
    </van-sticky> -->

    <div class="swap" v-bind:style="{ height: curHeight + 'px' }">
      <!-- <router-view class="content"></router-view> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" class="content">
          <!-- 这里是会被缓存的视图组件 -->
        </router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" class="content">     

      </router-view>
    </div>

    <van-tabbar v-model="active">
      <van-tabbar-item to="/Index" icon="home-o">首页</van-tabbar-item>
      <!-- <van-tabbar-item to="/GoodCategory" icon="search">分类</van-tabbar-item> -->
      <van-tabbar-item to="/GoodList" icon="search">商品列表</van-tabbar-item>
      <van-tabbar-item to="/Cart" icon="cart-o" :badge="cartNum">购物车</van-tabbar-item>
      <van-tabbar-item to="/MyCenter" icon="friends-o">个人中心</van-tabbar-item>
    </van-tabbar>

    <!-- <van-popup v-model="loginshow" round position="bottom" :style="{ height: '250px' }">
      <div class="login-form">
        <van-field v-model="tel" type="tel" label="手机号" />
        <van-field v-model="sms" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <template #button>
            <van-button size="small" :loading="smsLoading" @click="SendSms" type="primary">发送验证码</van-button>
          </template>
        </van-field>
        <div class="login-form-btn">
          <van-button round @click="Login" block="" type="info">登录</van-button>
        </div>
      </div>
    </van-popup> -->
    <!-- <img src="./assets/notice.jpg" fit="contain" width="100%" alt="" /> -->
    
  </div>
</template>
<script>
import { Dialog, Tabbar, TabbarItem,Toast } from "vant";
import { NavBar } from "vant";
import { Sticky } from "vant";
import { Popup } from "vant";
import { Button, Field } from "vant";
export default {
  data() {
    return {
      smsLoading: false,
      sms: "",
      tel: "",
      active: 0,
      currentUser: {},
    };
  },
  computed: {
    loginshow: {
      get() {
        return this.$store.state.loginShow;
      },
      set() {
        this.$store.commit("hideLogin");
      },
    },
    cartNum() {
      return this.$store.state.cartCount;
    },
  },
  methods: {
    ShowLogin() {
      this.$store.commit("showLogin");
    },

    SendSms() {
      // this.$toast('3123');
      if (this.tel != "") {
        var that = this;
        this.smsLoading = true;
        this.$http
          .get("Common/SendAuthCode", {
            params: {
              tel: this.tel,
              usertype: "sdworker",
            },
          })
          .then((res) => {
            that.smsLoading = false;
            if (res.data == "success") {
              that.$toast("发送成功!");
            } else {
              // that.$toast("网络异常");
              that.$toast(res.data);
            }
          });
      } else {
        that.$toast("请填写手机号");
      }
    },
    Login() {
      var that = this;
      if (this.tel == "") {
        that.$toast("请填写手机号");
      }
      this.$http
        .get("SDWorker/SDWorkerLogin", {
          params: {
            tel: this.tel,
            authcode: this.sms,
            agentid: 1,
          },
        })
        .then((res) => {
          if (res.data == "success") {
            that.$store.commit("login");
            that.$store.commit("hideLogin");
          } else {
            // that.$toast("网络异常");
            that.$toast(res.data);
          }
        });
    },
  },
  mounted() {
    var that = this;
    this.$http.get("SDWorker/CheckLogin").then((res) => {
      if (res.data == "success") {
          console.log(this.$route) ;
        that.$store.commit("login");
        that.$store.commit("hideLogin");
      }
    });
    // Dialog.alert({
    //   title: '温馨提示',
    //   message: '抽奖活动正在进行中，每次抽奖即可获得一次助力机会，可给自己助力也可给他人助力，经销商也可给同一水电工程师助力三次，成功助力十次活动结束后将一起平分十万元大奖。',
    //   theme: 'round-button',
    // });
  },
  beforeMount() {
    // var h = document.documentElement.clientHeight || document.body.clientHeight;
    var h = document.documentElement.clientHeight;

    this.curHeight = h - 80; //减去页面上固定高度height
    // this.curHeight=627;
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  background-color: #aeaeae14;
  height: 100%;
  overflow-y: auto;
}
.content {
  /* margin-bottom: 20px; */
  height: 100%;
}

.swap {
  position: relative;
  /* overflow: scroll; */
  z-index: 1;
}

.van-nav-bar {
  background: #fff;
  color: #3d4145;
  border-bottom: 1px solid #eee;
}
.login-form {
  padding-top: 30px;
  padding: 20px;
}
.login-form-btn {
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.count-down {
  padding-top: 10px;
}
</style>
